import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTrimVideo.meta';

export type TrackTrimVideoParams =
  | {
      trim_type: 'trim' | 'extend';
      location: 'front' | 'back';
    }
  | {
      trim_type: 'split';
    };

export const useTrackTrimVideo = () => {
  const { track } = useAnalyticsUtilities();

  const trackTrimVideo = useCallback(
    (params: TrackTrimVideoParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTrimVideo };
};
